import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { VideoService } from './video.service';
import { VideoData } from './video.model';

export class VideoDataSource implements DataSource<VideoData> {

  private dataSubject = new BehaviorSubject<VideoData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private videoService: VideoService) {}

  connect(collectionViewer: CollectionViewer): Observable<VideoData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadVideos(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'createdAt',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {
    this.loadingSubject.next(true);

    this.videoService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.video);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
